import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {Form, Input, SingleCheckbox} from '../Form';
import {handleChange, handleError} from '../../util/common';
import {AccountTypeName, StepType} from '../../util/types';
import {Modal} from '../Other';

class Login extends Component {
	state = {
		email: '',
		password: '',
		agreement: false,
		open: false,
		step: null,
		refreshError: false
	};

	componentDidMount() {
		const {check} = this.props;

		check();
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.loggedIn && this.props.loggedIn) {
			console.log('logged in');

			this.setState({
				open: false,
				email: '',
				password: ''
			});
		}

		if (!prevProps.loggedOut && this.props.loggedOut) {
			console.log('logged out');
		}

		if (!prevProps.authorized && this.props.authorized) {
			console.log('authorized');
		}

		if (prevProps.authorized && !this.props.authorized) {
			console.log('unauthorized');
		}

		if (!prevProps.registered && this.props.registered) {
			console.log('account registered');

			this.setState({
				password: '',
				step: StepType.CONFIRM
			});
		}

		if (!prevProps.restored && this.props.restored) {
			console.log('restoration email sent');
		}

		if (!prevProps.verificationResent && this.props.verificationResent) {
			console.log('verification email sent');
		}
	}

	signUpOn = () => {
		this.setState({
			open: true,
			step: StepType.SIGNUP_CHOOSE
		});
	}

	signInOn = () => {
		this.setState({
			open: true,
			step: StepType.SIGNIN
		});
	}

	handleError = (name, error) => handleError(this, name, error);

	handleChange = (name, value) => handleChange(this, name, value);

	logIn = () => {
		const {
			email,
			password,
			errors
		} = this.state;

		const {
			login
		} = this.props;

		if (errors.email || errors.password) {
			console.log('error');
			return false;
		}

		login(email, password);

		return true;
	}

	register = () => {
		const {
			email,
			password,
			agreement,
			step,
			errors
		} = this.state;

		const {
			register
		} = this.props;

		if (errors.email || errors.password || errors.agreement) {
			console.log('error');
			return false;
		}

		if (!agreement) {
			console.log('accept rules');
			return false;
		}

		register({
			email,
			password,
			account_type: step === StepType.SIGNUP_AS_THERAPIST ? AccountTypeName.THERAPIST : AccountTypeName.CLIENT
		});

		this.setState({step: StepType.CONFIRM});

		return true;
	}

	restore = () => {
		const {
			email,
			errors
		} = this.state;

		const {
			restore
		} = this.props;

		if (errors.email) {
			console.log('error');
			return false;
		}

		restore(email);

		return true;
	}

	reset = () => {
		// TODO
	}

	resendVerification = () => {
		const {
			email
		} = this.state;

		const {
			resendVerification
		} = this.props;

		resendVerification(email);

		return true;
	}

	render() {
		const {
			email,
			password,
			agreement,
			open,
			step,
			refreshError
		} = this.state;

		const {
			authorized,
			logout
		} = this.props;

		return (
			<>
				{
					authorized ? (
						<div className="login">
							<button
								type="button"
								onClick={logout}
							>
								wyloguj
							</button>
						</div>
					) : (
						<div className="login">
							<button
								type="button"
								onClick={this.signUpOn}
							>
								założ konto
							</button>

							<button
								type="button"
								onClick={this.signInOn}
							>
								zaloguj
							</button>
						</div>
					)
				}
				{
					open && (
						<>
							{
								step === StepType.SIGNIN && (
									<Modal className="login-modal with-footer" title="Logowanie">
										<Form>
											<Input
												handleChange={this.handleChange}
												handleError={this.handleError}
												name="email"
												value={email}
												type="email"
												placeholder="adres e-mail/nick"
												refreshError={refreshError}
												required
											/>
											<Input
												handleChange={this.handleChange}
												handleError={this.handleError}
												name="password"
												value={password}
												type="password"
												placeholder="hasło"
												refreshError={refreshError}
												pattern=".{8,}"
												required
											/>
											<button
												type="button"
												onClick={() => this.setState({step: StepType.RESTORE})}
												className="restore"
											>
												<p>zapomniałeś hasła?</p>
											</button>
											<button
												type="button"
												className="btn normal"
												onClick={this.logIn}
											>
												Zaloguj się
											</button>
										</Form>
										<div className="footer">
											<button
												type="button"
												onClick={() => this.setState({step: StepType.SIGNUP_CHOOSE})}
											>
												<p>Nie masz konta?</p>
												<p>Zarejestruj się</p>
											</button>
										</div>
									</Modal>
								)
							}
							{
								step === StepType.RESTORE && ( // TODO
									<Modal className="login-modal" title="Zresetuj hasło">
										<Input
											handleChange={this.handleChange}
											handleError={this.handleError}
											name="password"
											value={password}
											type="password"
											placeholder="hasło"
											refreshError={refreshError}
											pattern=".{8,}"
											required
										/>
										<button
											type="button"
											onClick={this.restore}
											className="restore"
										>
											<p>wyślij email</p>
										</button>
									</Modal>
								)
							}
							{
								step === StepType.RESET && ( // TODO
									<Modal className="login-modal" title="Podaj nowe hasło">
										<Input
											handleChange={this.handleChange}
											handleError={this.handleError}
											name="password"
											value={password}
											type="password"
											placeholder="hasło"
											refreshError={refreshError}
											pattern=".{8,}"
											required
										/>
										<Input
											handleChange={this.handleChange}
											handleError={this.handleError}
											name="password"
											value={password}
											type="password"
											placeholder="hasło"
											refreshError={refreshError}
											pattern=".{8,}"
											required
										/>
										<button
											type="button"
											onClick={this.reset}
											className="restore"
										>
											<p>zmień hasło</p>
										</button>
									</Modal>
								)
							}
							{
								step === StepType.SIGNUP_CHOOSE && (
									<Modal className="login-modal" title="Zarejestruj się jako">
										<div className="image-picker">
											<button
												type="button"
												onClick={() => this.setState({step: StepType.SIGNUP_AS_CLIENT})}
											>
												<img
													alt="client"
													src={`${process.env.PUBLIC_URL}/static/images/user_signup.png`}
												/>
											</button>
											<button
												type="button"
												onClick={() => this.setState({step: StepType.SIGNUP_AS_THERAPIST})}
											>
												<img
													alt="spec"
													src={`${process.env.PUBLIC_URL}/static/images/specialist_signup.png`}
												/>
											</button>
										</div>
										<div className="row">
											<div className="col-6-12">
												<button
													type="button"
													className="btn normal"
													onClick={() => this.setState({step: StepType.SIGNUP_AS_CLIENT})}
												>
													Użytkownik
												</button>
											</div>
											<div className="col-6-12">
												<button
													type="button"
													className="btn normal"
													onClick={() => this.setState({step: StepType.SIGNUP_AS_THERAPIST})}
												>
													Specjalista
												</button>
											</div>
										</div>
									</Modal>
								)
							}
							{
								step === StepType.SIGNUP_AS_THERAPIST && (
									<Modal className="login-modal with-footer" title="Zarejestruj się jako specjalista">
										<Form>
											<Input
												handleChange={this.handleChange}
												handleError={this.handleError}
												name="email"
												value={email}
												type="email"
												placeholder="adres e-mail/nick"
												refreshError={refreshError}
												required
											/>
											<Input
												handleChange={this.handleChange}
												handleError={this.handleError}
												name="password"
												value={password}
												type="password"
												placeholder="hasło"
												refreshError={refreshError}
												pattern=".{8,}"
												required
											/>
											<SingleCheckbox
												handleChange={this.handleChange}
												name="agreement"
												value={agreement}
												checkboxLabel="zapoznałem się i akceptuję regulamin"
											/>
											<button
												type="button"
												className="btn normal"
												onClick={this.register}
											>
												Zarejestruj się
											</button>
										</Form>
										<div className="footer">
											<button
												type="button"
												onClick={() => this.setState({step: StepType.SIGNIN})}
											>
												<p>Masz konto?</p>
												<p>Zaloguj się</p>
											</button>
										</div>
									</Modal>
								)
							}
							{
								step === StepType.SIGNUP_AS_CLIENT && (
									<Modal className="login-modal with-footer" title="Zarejestruj się jako użytkownik">
										<Form>
											<Input
												handleChange={this.handleChange}
												handleError={this.handleError}
												name="email"
												value={email}
												type="email"
												placeholder="adres e-mail/nick"
												refreshError={refreshError}
												required
											/>
											<Input
												handleChange={this.handleChange}
												handleError={this.handleError}
												name="password"
												value={password}
												type="password"
												placeholder="hasło"
												refreshError={refreshError}
												pattern=".{8,}"
												required
											/>
											<SingleCheckbox
												handleChange={this.handleChange}
												name="agreement"
												value={agreement}
												checkboxLabel="zapoznałem się i akceptuję regulamin"
											/>
											<button
												type="button"
												className="btn normal"
												onClick={this.register}
											>
												Zarejestruj się
											</button>
										</Form>
										<div className="footer">
											<button
												type="button"
												onClick={() => this.setState({step: StepType.SIGNIN})}
											>
												<p>Masz konto?</p>
												<p>Zaloguj się</p>
											</button>
										</div>
									</Modal>
								)
							}
							{
								step === StepType.CONFIRM && (
									<Modal className="login-modal" title="Dokończ rejestrację">
										<div className="image-picker">
											<img
												alt="client"
												src={`${process.env.PUBLIC_URL}/static/images/at_signup.png`}
											/>
											<img
												alt="spec"
												src={`${process.env.PUBLIC_URL}/static/images/specialist_signup.png`}
											/>
										</div>
										<div className="footer">
											<button
												type="button"
												onClick={this.resendVerification}
											>
												<p>E-mail nie dotarł?</p>
												<p>Wyślij jeszcze raz</p>
											</button>
										</div>
									</Modal>
								)
							}
						</>
					)
				}
			</>
		);
	}
}

Login.propTypes = {
	check: PropTypes.func.isRequired,
	authorized: PropTypes.bool.isRequired,
	login: PropTypes.func.isRequired,
	loggedIn: PropTypes.bool.isRequired,
	logout: PropTypes.func.isRequired,
	loggedOut: PropTypes.bool.isRequired,
	register: PropTypes.func.isRequired,
	registered: PropTypes.bool.isRequired,
	restore: PropTypes.func.isRequired,
	restored: PropTypes.bool.isRequired,
	resendVerification: PropTypes.func.isRequired,
	verificationResent: PropTypes.bool.isRequired
};

export default Login;
